<template>
    <v-container fluid class="pa-0 pb-8">
      <v-container class="container-custom">
        <Breadcrumbs
          :title="$t('modules.cards_configuration.update.breadcrumbs.title')"
          :description="$t('modules.cards_configuration.update.breadcrumbs.description')"
        >
        </Breadcrumbs>
        <v-row>
          <v-col>
            <OutlinedCard>
              <v-row>
                <v-col>
                  <h2>{{ $t('modules.cards_configuration.update.cardConfiguration.account.title') }}</h2>
                  <div>{{ $t('modules.cards_configuration.update.cardConfiguration.account.subtitle') }}</div>
                  <v-autocomplete
                    class="mr-4 my-4"
                    label="Cuenta"
                    item-value="id"
                    item-text="name"
                    :items="accountsList"
                    v-model="selectedAccount"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <h2>{{ $t('modules.cards_configuration.update.cardConfiguration.bank.title') }}</h2>
                  <div>{{ $t('modules.cards_configuration.update.cardConfiguration.bank.subtitle') }}</div>
                  <v-autocomplete
                    class="mr-4 my-4"
                    label="Banco"
                    item-value="id"
                    item-text="issuer"
                    :items="banksList"
                    v-model="selectedBank"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <h2>{{ $t('modules.cards_configuration.update.cardConfiguration.card.title') }}</h2>
                  <div>{{ $t('modules.cards_configuration.update.cardConfiguration.card.subtitle') }}</div>
                  <v-autocomplete
                    class="mr-4 my-4"
                    label="Tarjeta"
                    item-value="id"
                    item-text="name"
                    :items="cardsList"
                    v-model="selectedCard"
                    outlined
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </OutlinedCard>
            <OutlinedCard>
              <h2>{{ $t('modules.cards_configuration.update.dates.title') }}</h2>
              <v-row>
                <v-col>
                  <h3>{{ $t('modules.cards_configuration.update.dates.start') }}</h3>
                  <v-date-picker
                  scrollable
                  v-model="startDate"
                  ></v-date-picker>
                </v-col>
                <v-col>
                  <h3>{{ $t('modules.cards_configuration.update.dates.end') }}</h3>
                  <v-date-picker
                  scrollable
                  v-model="finishDate"
                  ></v-date-picker>
                </v-col>
              </v-row>
            </OutlinedCard>
            <OutlinedCard>
              <h2>{{ $t('modules.cards_configuration.update.disclaimerInterest.title') }}</h2>
              <h5>{{ $t('modules.cards_configuration.update.disclaimerInterest.disclaimerText') }}</h5>
              <v-checkbox
                label="Posee interés"
                class="mt-0 ml-0 AsideBar-checkbox"
                color="primary"
                v-model="hasInterests"
              ></v-checkbox>
            </OutlinedCard>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-end">
          <Button
            white
            :text="$t('actions.cancel')"
            @end="resetButtonValues"
            @clicked="$router.replace('/cards-configuration')"
            class="mr-4 mb-6"
          ></Button>
          <Button
            :loading="createButton.loading"
            :success="createButton.success"
            :error="createButton.error"
            :text="$t('actions.save')"
            :successText="$t('actions.saved')"
            :errorText="$t('actions.error')"
            :disabled="!canUpdate"
            @end="resetButtonValues"
            @clicked="updateCardConfiguration"
            class="mr-4 mb-6"
          ></Button>
        </v-row>
      </v-container>
    </v-container>
  </template>
  
  <script>
  import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
  import Button from '@/components/Button/Button';
  import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
  import { $cardsConfiguration } from '../Services';
  
  export default {
      name: 'CardConfigurationUpdate',
      components: {
              Breadcrumbs,
              Button,
              OutlinedCard
        },
      props:{
  
      },
      data() {
          return {
            createButton: {
              loading: false,
              success: false,
              error: false
            },
            cardsList: [],
            accountsList: [],
            banksList: [],
            selectedCard: null,
            selectedAccount: null,
            selectedBank: null,
            startDate: null,
            finishDate: null,
            hasInterests: null,
            hasError: null
          }
      },
      methods: {
        async fetchCurrentCardConfiguration(id) {
          try {
            const response = await $cardsConfiguration.getCardConfiguration(id);
            const cardConfig = response.data;

            this.selectedCard = cardConfig.cardId;
            this.selectedBank = cardConfig.bankId;
            this.selectedAccount = cardConfig.accountId;
            this.hasInterests = cardConfig.interests;
            this.startDate = cardConfig.fromDate;
            this.finishDate = cardConfig.toDate;
    } catch (error) {
      this.hasError = true;
    }
        },
        clearData() {
          this.resetButtonValues();
        },
        resetButtonValues() {
          this.createButton.loading = false;
          this.createButton.success = false;
          this.createButton.error = false;
        },
        async updateCardConfiguration() {
        this.createButton.loading = true;
        this.createButton.error = false;
        try{
            const selectedId = this.$route.params.id; 
            const updatedConfig = {
              id: selectedId,
              bankId: this.selectedBank,
              cardId: this.selectedCard,
              accountId: this.selectedAccount,
              interest: !!this.hasInterests,
              from: this.startDate,
              to: this.finishDate,
            };
          if (this.validateDates()) {
            await $cardsConfiguration.updateCardConfiguration(selectedId, updatedConfig);
            this.createButton.success = true;
            this.$router.replace('/cards-configuration');
          } else {
            this.$store.dispatch('commons/openPopUp', {
              title: this.$t('modules.cards_configuration.table.error_message.dates_error'),
              content: [
                {
                  value: 'La fecha \'Hasta\' debe ser mayor a la fecha \'Desde\'.',
                }
              ],
              actionPrimary: { text: 'Aceptar', callback() {} },
              icon: { color: 'warning', name: 'mdi-eye-off-outline' },
              color: 'primary'
            });
          }
        } catch(error) {
          this.createButton.error = true;
          throw error;
        } finally{
          this.createButton.loading = false;
        }
      },
      async fetchCards() {
        try {
          const response = await $cardsConfiguration.getCards()
          this.cardsList = response.data
        } catch(error) {
          this.hasError = true
        }
      },
      async fetchBanks() {
        try {
          const response = await $cardsConfiguration.getBanks()
          this.banksList = response.data
        } catch(error) {
          this.hasError = true
        }
      },
      async fetchAccounts() {
        try {
          const response = await $cardsConfiguration.getAccounts(false)
          this.accountsList = response.data
        } catch(error) {
          this.hasError = true
        }
      },
      validateDates() {
        return this.startDate && this.finishDate && (this.finishDate > this.startDate);
      }
      },
    mounted() {
      const selectedId = this.$route.params.id
      this.fetchCurrentCardConfiguration(selectedId);
      this.fetchCards();
      this.fetchBanks();
      this.fetchAccounts();
    },
      watch: {
  
      },
      computed: {
        canUpdate() {
          return this.$permissions.portaladministrativo.prices.interest.UPDATE;
        },
      },
  }
  </script>